import React from 'react'
import { Typography } from '@mui/material'
import PropTypes from 'prop-types'

import { styles } from './notes-properties.styles'

const PropertyAlert = ({ title, description }) => {
  return (
    <>
      <Typography typography="small" color="gray.64" sx={styles.propertyTitle}>
        {title}
      </Typography>
      <Typography typography="medium" color="gray.80" sx={styles.propertyDescription}>
        {description}
      </Typography>
    </>
  )
}

export default PropertyAlert

PropertyAlert.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
}

PropertyAlert.defaultProps = {
  title: '',
  description: '',
}
